module.exports = __webpack_public_path__ + "static/media/rouletteStart_2.e0e231bc.mp3";